"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky v plnej zhode (tak ako je zadany) v multilang fieldoch.
 *
 * Napriklad:
 * 'aáaa' =$match=> 'aaaa'
 * 'aáaa' =! $match=> 'aaaaaa'
 * 'aáaa aaa' =$match=> 'aaaa aaa'
 * 'aáaa aaa' =! $match=> 'aaaa aaaa'
 *
 * @param {string} fieldName
 * @param {string} value
 * @param {string} language
 * @param {Object} [opts = {}]
 * @param {string} [opts.languageField = 'language']
 * @param {string} [opts.textField = 'text']
 *
 * @returns {Object}
 */
var textMultilangMatchToQuery = function textMultilangMatchToQuery(fieldName, value, language) {
  var _$elemMatch;

  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, fieldName, {
    $elemMatch: (_$elemMatch = {}, (0, _defineProperty2.default)(_$elemMatch, opts.languageField || 'language', language), (0, _defineProperty2.default)(_$elemMatch, opts.textField || 'text', {
      $match: value
    }), _$elemMatch)
  });
};

var _default = textMultilangMatchToQuery;
exports.default = _default;